export const ProvinceCapitals: { [key: string]: string } = {
  "DRN": "Assen",         // Drenthe
  "FLV": "Lelystad",      // Flevoland
  "FRI": "Leeuwarden",    // Friesland
  "GEL": "Arnhem",        // Gelderland
  "GRN": "Groningen",     // Groningen
  "LIM": "Maastricht",    // Limburg
  "NB": "’s-Hertogenbosch", // Noord-Brabant
  "NH": "Haarlem",        // Noord-Holland
  "OVR": "Zwolle",        // Overijssel
  "UTR": "Utrecht",       // Utrecht
  "ZLD": "Middelburg",    // Zeeland
  "ZHH": "Den Haag"       // Zuid-Holland
};